export enum SearchEventType {
  UNRANKED = "unranked",
  PROGRESS = "ranking-inprogress",
  FINAL = "ranked",
}

export enum ResultDataKeys {
  HIGH = "most-relevant",
  LOW = "relevant"
}

export interface ResultData {
  [ResultDataKeys.HIGH]?: number[];
  [ResultDataKeys.LOW]?: number[];
}

export interface StatusData {
  completed: number;
  total: number;
}

export interface UnrankedEvent {
  event_type: SearchEventType.UNRANKED;
  data: ResultData;
}

export interface FinalEvent {
  event_type: SearchEventType.FINAL;
  data: ResultData;
}

export interface StatusEvent {
  event_type: SearchEventType.PROGRESS;
  data: StatusData;
}

export type SearchEvent = UnrankedEvent | FinalEvent | StatusEvent;
